import styled from 'styled-components';
import Button from '../../Button';
import { IoClose } from 'react-icons/io5';
import {
    detailsBackground,
    primaryColorLight,
    primaryColor
} from '../../../config/colors';

export const IdCardWrapper = styled.div`
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  padding-bottom: 60px;
`;

export const TitleAndCommandsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const TitlesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 25px;
  margin-left: 65px;
  margin-bottom: 30px;
  padding: 0;
  flex-grow: 1;
  flex-wrap: wrap;
  p:not(:last-of-type) {
    margin-bottom: 15px;
  }
`;

export const IdCardTitle = styled.h1`
  margin: 0px;
  margin-bottom: 15px;
  font-weight: 500;
  font-size: 1.8rem;
  display: inline-flex;
`;

export const ModuleTitle = styled.div`
  font-weight: 500;
  font-size: 1.25rem;
  display: inline-flex;
  margin-bottom: 12px;
`;

export const CommandsWrapper = styled.div`
  display: flex;
  padding: 4px;
  position: relative;
  position: relative;
  justify-content: end;
  position: sticky;
`;

export const PrintButton = styled(Button).attrs({
    wrapperStyle: {
        width: '84px',
        height: '32px',
        marginRight: '10px',
        marginTop: '10px',
    },
})``;

export const ExitButton = styled(Button).attrs({
    wrapperStyle: {
        width: '42px',
        height: '42px',
        marginTop: '5px',
    },
    type: 'rounded',
    icon: IoClose,
    iconProps: {
        color: 'white',
        size: '22px',
    },
})``;

export const EditButton = styled(Button).attrs({
    wrapperStyle: {
        width: '84px',
        height: '32px',
        marginRight: '10px',
        marginTop: '10px',
    },
})``;

export const DetailsWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  padding-left: 50px;
  padding-right: 30px;
`;

export const TextualDetailsWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding-right: 30px;
`;

export const VisualDetailsWrapper = styled.div`
  max-height: 520px;
  flex: 1;
  flex-direction: column;
`;

export const SectionTitle = styled(ModuleTitle)`
  margin-left: 15px;
`;

export const SectionTitleEmbedded = styled(ModuleTitle)`
  margin: -20px 0 -5px 0;
  padding-left: 15px;
  padding-top: 5px;
  background-color: ${detailsBackground};
`;

export const SectionTitleEl = styled.div`
  display: inline-block;
  min-width: 380px;
`;

export const ImagesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 20px;
`;

export const ImageWrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
  flex:1;
  margin-left: 20px;
`;

export const CharacteristicsAndModulesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top:1em;
`;

export const CharacteristicsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const CharacteristicsSectionWrapper = styled.div`
  margin-bottom: 20px;
`;

export const CharacteristicWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: 15px;
  margin-bottom: 3px;
`;

export const CharacteristicTitle = styled.div`
  flex: 1;
  color: ${primaryColorLight}
`;

export const CharacteristicValue = styled.div`
  flex: 1;
`;

export const ModulesWrapper = styled.div`
  flex-direction: column;
  flex: 1;
`;

export const ModuleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 35px;
  cursor: pointer;
`;

export const ModuleImage = styled.div`
  flex: 1;
`;

export const ModuleNameWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 5;
  align-items: center;
  &:hover {
    color: ${primaryColor};
  }
`;

export const ModuleTsCode = styled.div`
  flex: 1;
`;

export const ModuleName = styled.div`
  flex: 4;
`;

export const SubMenusWrapper = styled.ul`
  display: flex;
  flex: 1;
  flex-direction: column;

  margin-top: 20px;
`;

export const SlotLoaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 50px;
`;
